import { ACPVariant } from 'apps/acp/variants/acp-variant';

const colors = {
  neutral: {
    color50: '#fcfcfc',
    color100: '#f0f3f3',
    color200: '#f0f0f0',
    color300: '#cccccc',
    color400: '#b3b3b3',
    color500: '#999999',
    color600: '#666666',
    color700: '#333333',
    color800: '#222222',
    color900: '#111111'
  },
  default: {
    color50: '#d9e8ec',
    color100: '#b4d1d8',
    color200: '#8ebac5',
    color300: '#68a3b1',
    color400: '#438c9e',
    color500: '#1d758a',
    color600: '#175e6e',
    color700: '#114653',
    color800: '#0c2f37',
    color900: '#06171c'
  },
  accent: {
    color50: '#fcf8f3',
    color100: '#f8f1e7',
    color200: '#f5ebdb',
    color300: '#f1e4cf',
    color400: '#eeddc3',
    color500: '#ead6b7',
    color600: '#bbab92',
    color700: '#8c806e',
    color800: '#5e5649',
    color900: '#2f2b25'
  },
  positive: {
    color50: '#e2e9de',
    color100: '#c5d3be',
    color200: '#a8be9d',
    color300: '#8aa87c',
    color400: '#6d925c',
    color500: '#507c3b',
    color600: '#40632f',
    color700: '#304a23',
    color800: '#203218',
    color900: '#10190c'
  },
  negative: {
    color50: '#f8d5dd',
    color100: '#f1aabb',
    color200: '#ea8099',
    color300: '#e35576',
    color400: '#dc2b54',
    color500: '#d50032',
    color600: '#aa0028',
    color700: '#80001e',
    color800: '#550014',
    color900: '#2b000a'
  },
  special: {
    color50: '#f8f4e0',
    color100: '#f1e8c1',
    color200: '#ebdda3',
    color300: '#e4d184',
    color400: '#ddc665',
    color500: '#d6ba46',
    color600: '#ab9538',
    color700: '#80702a',
    color800: '#564a1c',
    color900: '#2b250e'
  }
};

const variant: ACPVariant = {
  id: 'www.aceflareaccount.com',
  productTitle: 'ACE Flare Account',
  productType: 'consumer_dda',
  accessDomain: {
    subdomain: 'www',
    domain: 'aceflareaccount',
    topLevelDomain: 'com'
  },
  colors,
  legacyAcpTheme: 'ace-flare',
  legacyAcpBrandName: 'aceflare',
  legacyLegosTheme: 'ace-flare',
  status_bar_background_color: colors.default.color500,
  status_bar_foreground_color: 'light',
  themeConfiguration: {
    tileIcon: {
      positive: {
        color50: '#ffffff',
        color100: '#ffffff',
        color200: '#ffffff',
        color300: '#ffffff'
      }
    }
  },
  contactInfo: {
    name: 'ACE Flare Account',
    contact_address_line1: 'PO Box 2136',
    contact_address_line2: 'Austin, TX 78768-2136',
    contact_address_line3: '',
    customer_support_email: 'customerservice@aceflareaccount.com',
    fax_formatted: '(512) 857-0263',
    phone_formatted: '(866) 753-6355',
    phone: '8667536355',
    phone_international: '737-220-8956',
    balance_check_phone: '8667536355',
    balance_check_phone_formatted: '(866) 753-6355',
    pre_funded_checks_phone: '18778147683',
    pre_funded_checks_phone_formatted: '1-877-814-7683'
  },
  configuration: {
    apiKeys: {
      appsFlyerDevKey: '5Us7NeWk6WVjGLsAnKioSk',
      appsFlyerBannerKey: 'a30cdd1b-cda5-4792-8bb1-5ffd0e2a62d6',
      'google-tag-manager-container-id': 'GTM-NQXKPD',
      'google-tag-manager-container-id-mobile': 'GTM-MWBTT5M',
      paypalFraudNetPayerIdProd: '',
      paypalFraudNetPayerIdTest: ''
    },
    featureToggles: {
      activationSetExternalId: false,
      appsFlyerEnabled: false,
      combinedTransactionsMasterAndSub: false,
      'embedded-activation': true,
      embeddedPayNearMe: false,
      hasNotificationCenter: false,
      mobilePBREnabled: true,
      preOnboardingEnabled: false,
      showAccountDisplayNickname: false,
      showAcquisitionLink: false,
      showATMFriendlyCards: true,
      showDisplayNameForSubAccount: false,
      showEmailInformationButton: true,
      showFeePlanPage: false,
      showHowToEarnRewardPointLink: true,
      showRegisterLink: true,
      showScanCardRegistration: false,
      showMarketingSiteLink: true,
      showFreeAtmFinderLink: false,
      showWUTransfers: false,
      showReloadLocationLink: false
    },
    misc: {
      distributor: 'ACE',
      layoutComponentOverride: false,
      loader: 'generic',
      payNearMeButtonTextColor: '#FFFFFF',
      payNearMeActionBarBackgroundColor: '#1D758A',
      payNearMeTitleTextColor: '#FFFFFF',
      payNearMeColorAccent: '#1D758A',
      marketingSiteUrl: 'https://www.flareaccount.com',
      marketingSiteLinkText: 'Flareaccount.com',
      locationSearchMax: '25',
      iOSAppId: '1243790889'
    },
    content: {
      signUpDisclaimerContent:
        'Account opening subject to verification of identity.'
    },
    disclaimers: {},
    sections: [
      'dashboard-gpr',
      'dashboard-lite',
      'dashboard-handoff',
      'layout',
      'manage-gpr',
      'move-money',
      'overdraft',
      'locations',
      'direct-deposit',
      'direct-deposit-mobile-panel',
      'statements',
      'contact-us',
      'restrictions-readonly',
      'feeplan',
      'western-union',
      'disclosure-dictionary',
      'check-deposit',
      'checks',
      'quickbooks-oauth',
      'points',
      'post-handoff-to-activate-register',
      'upgrade',
      'offers',
      'offers-intro',
      'tours',
      'post-install-multi-screen-acquisition-flow',
      'echecks',
      'external-loyalty',
      'secure-inbox',
      'benefit-center',
      'atm-finder',
      'savings',
      'pay-bills',
      'premier-plan',
      'activation',
      'savings-transfer',
      'anytime-alerts',
      'anytime-alerts-upgrade',
      'change-username',
      'change-password',
      'mobile-check-load',
      'feedback',
      'rent-track',
      'direct-deposit-form',
      'dynamic-faq',
      'billpay',
      'card',
      'refer-a-friend',
      'close-account',
      'points-learn-more',
      'family-cards',
      'bank-transfers',
      'handoff',
      'debit-card-transfers',
      'card-use-settings',
      'secure-upload',
      'digital-wallet',
      'me-to-me-transfer',
      'money-gram',
      'survey',
      'debit-card-transfers-disbursement',
      'spend-money',
      'fraud-detection',
      'spending-tracker',
      'connected-banks',
      'interstitials',
      'dd-tracker'
    ]
  }
};

export default variant;
